export default __webpack_public_path__ + "static/media/MATH-BUSD.3b82538f.svg";